import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { HuddleChatInput, Message } from '@avslack/shared';
import { listHuddleChat, sendHuddleChat } from '../lib/api';

/**
 * Az olelesben valtott uzenetek.
 *
 * **Miert kerdezzuk ra, es nem varjuk az esemenyt?** A hivas SAJAT ablakban
 * fut, amiben nincs valos ideju kapcsolat (nincs `RealtimeProvider`) - a
 * kapcsolatot szandekosan a fo ablak tartja. A gyors utat a media-adatcsatorna
 * jelzese adja (lasd `HuddleProvider.notifyChat`), ez a rendszeres lekerdezes
 * pedig a halo alatta: ha egy jelzes elveszik, a chat legfeljebb par
 * masodpercet kesik, de nem marad ki uzenet.
 */
export const huddleChatKey = (huddleId: string) => ['huddle-chat', huddleId] as const;

const REFETCH_MS = 5000;

export function useHuddleChat(huddleId: string | null) {
  return useQuery({
    queryKey: huddleChatKey(huddleId ?? ''),
    enabled: Boolean(huddleId),
    queryFn: () => listHuddleChat(huddleId!),
    refetchInterval: REFETCH_MS,
  });
}

export function useSendHuddleChat(huddleId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<HuddleChatInput, 'clientMsgId'>) =>
      sendHuddleChat(huddleId!, {
        ...input,
        // Idempotencia: egy ujrakuldes nem hoz letre masodik uzenetet.
        clientMsgId: `hc-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      }),
    /*
      A sajat uzenetunk AZONNAL megjelenik.

      A lekerdezes 5 masodpercenkent fut; enelkul a sajat mondatunk lathatatlan
      lenne addig, mikozben a hivasban mar valaszolnak ra. A szerver valasza a
      hiteles - ez csak megelozi.
    */
    onSuccess: (message: Message) => {
      queryClient.setQueryData<Message[]>(huddleChatKey(huddleId ?? ''), (current) => {
        if (!current) return [message];
        if (current.some((item) => item.id === message.id)) return current;
        return [...current, message];
      });
    },
  });
}
